import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import range from '../shared/range'
import IDictionary from 'src/models/IDictionary'

interface IHeightInputProps {
  heightFeet?: number
  heightInches?: number
  onChange: React.ChangeEventHandler
  onBlur: (e: any) => void
  validateEntry: IDictionary<boolean>
}

const HeightInput: React.SFC<IHeightInputProps> = ({
  heightFeet,
  heightInches,
  onChange,
  onBlur,
  validateEntry
}) => (
  <>
    <Grid item xs={6}>
      <FormControl
        fullWidth
        required
        error={validateEntry.heightFeet && heightFeet === undefined}>
        <InputLabel htmlFor="heightFeet">Height (feet)</InputLabel>
        <Select
          name="heightFeet"
          value={(heightFeet || '').toString()}
          onChange={onChange}
          onBlur={onBlur}>
          {range(4, 7).map(feet => (
            <MenuItem value={feet.toString()} key={feet}>
              {feet}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <FormControl
        fullWidth
        required
        error={validateEntry.heightInches && heightInches === undefined}>
        <InputLabel htmlFor="heightInches">Height (inches)</InputLabel>
        <Select
          name="heightInches"
          value={(heightInches || '').toString()}
          onChange={onChange}
          onBlur={onBlur}>
          {range(1, 12).map(inches => (
            <MenuItem value={inches.toString()} key={inches}>
              {inches}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  </>
)

export default HeightInput



// WEBPACK FOOTER //
// ./src/components/contest/HeightInput.tsx